export default "__VITE_ASSET__B0_VZa8z__"